import React from 'react';
import '../../styles/components/AsperaDetailsData.scss';
/**
 * React Component
 *
 * The AsperaDetailsData renders the details data for stuff like Package Details and other key:value pairs
 *
 * @example
 * ```javascript
 * <AsperaDetailsData items={this.items} />
 * ```
 */
export class AsperaDetailsData extends React.Component {
    render() {
        const { items, className, stacked, boldHeaders, showColonDivider } = this.props;
        return (React.createElement("div", { className: `aspera-details-data ${className ? className : ''} ${stacked ? 'stacked' : ''}` }, items.filter(item => !item.hidden).map((item, index) => {
            return (React.createElement("div", { key: index, className: "item-pair" },
                React.createElement("div", { className: `item-key ${(boldHeaders || item.boldLink) ? 'bold-header' : ''}` },
                    item.key || '',
                    showColonDivider ? ':' : ''),
                React.createElement("div", { className: `item-value ${item.boldLink ? 'bold-header' : ''}` }, item.value || '')));
        })));
    }
}
